<template>
    <div class="Order">
    <base-list-management ref="baseListManagement" :configData.sync="configData"/>
    </div>
  </template>

<script>
import { getPurchaseProviderList } from '../maintenanceCommonServices/services'
import config from './config'
import moment from 'moment'
import { pickBy as ommitEmptyFields } from 'lodash'

export default {
  data() {
    const {
      configData,
    } = config.call(this)
    return {
      configData,
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    handleGoToDetail(row) {
      this.$router.push({
        name: 'maintenanceOrderDetail',
        query: {
          orderId: row.orderId,
        },
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    getSectionTime(day = -6, formData = 'YYYY-MM-DD HH:mm:ss') {
      let startTime = ''
      let enTime = ''
      if (day < 0) {
        startTime = `${moment().add(day, 'days').format(formData).substring(0, 11)}00:00:00`
        enTime = `${moment(new Date().getTime()).format(formData).substring(0, 11)}23:59:59`
      } else {
        startTime = `${moment(new Date().getTime()).format(formData).substring(0, 11)}00:00:00`
        enTime = `${moment().add(day, 'days').format(formData).substring(0, 11)}23:59:59`
      }

      return [startTime, enTime]
    },
    // eslint-disable-next-line vue/no-unused-properties
    search(params) {
      if (params.createTime && params.createTime.length) {
        params.refundStartTime = moment(params.createTime[0]).valueOf()
        params.refundEndTime = moment(params.createTime[1]).valueOf()
      }
      delete params.createTime

      return ommitEmptyFields(params)
    },
    // 获取维保服务商名称(ok)
    async getmaintenanceISP() {
      const { data, code } = await getPurchaseProviderList()
      if (code === 1) {
        this.configData.formData.list.forEach((item) => {
          if (item.itemConfig.prop === 'tenantId') {
            data.forEach((ite) => {
              ite.tenantName = `${ite.tenantName}(${ite.tenantId})`
            })
            this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'tenantId', data })
          }
        })
      }
    },
  },
  mounted() {
    this.getmaintenanceISP()
  },
}
</script>
  <style>
  </style>
